/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DashboardFilterObiettiviPlDto interface.
 */
export function instanceOfDashboardFilterObiettiviPlDto(value) {
    return true;
}
export function DashboardFilterObiettiviPlDtoFromJSON(json) {
    return DashboardFilterObiettiviPlDtoFromJSONTyped(json, false);
}
export function DashboardFilterObiettiviPlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fkStrutturaDelivery': json['fkStrutturaDelivery'] == null ? undefined : json['fkStrutturaDelivery'],
        'fkPl': json['fkPl'] == null ? undefined : json['fkPl'],
        'fkPlv2': json['fkPlv2'] == null ? undefined : json['fkPlv2'],
        'delegato': json['delegato'] == null ? undefined : json['delegato'],
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
    };
}
export function DashboardFilterObiettiviPlDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fkStrutturaDelivery': value['fkStrutturaDelivery'],
        'fkPl': value['fkPl'],
        'fkPlv2': value['fkPlv2'],
        'delegato': value['delegato'],
        'page': value['page'],
        'size': value['size'],
    };
}
